/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum DistributionType {
    DownloadFromVeeamServers,
    DownloadFromFileShare,
}
